// EXAMPLE


import React from 'react';
import {
    TouchableOpacity,
    View,
    Image,
    StyleProp,
    ViewStyle, Text
} from 'react-native';

const CHECKED_BOX = require('../../assets/checked.png');
const UNCHECKED_BOX = require('./../../assets/check.png');


interface ICheckboxProps {
    onPress?: any;
    label: string;
    headerStyle?: StyleProp<ViewStyle>;
    value: boolean;
    disabled?: boolean;
}

export const Checkbox = function (props: ICheckboxProps) {
    const {headerStyle, onPress, value, label, disabled} = props;
    return (
        <TouchableOpacity
            style={[{
                alignSelf: "flex-start",
                paddingVertical: 10,
                paddingHorizontal: 0
            }, headerStyle]}
            disabled={disabled}
            onPress={() => {
                onPress ? onPress(!value) : null;
            }}
        >
            <View style={[{
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center"
            }]}>
                <View style={{marginRight: 10}}>
                    <Image source={value ? CHECKED_BOX : UNCHECKED_BOX}
                           style={{width: 20, height: 20}}
                           resizeMode="contain"/>
                </View>
                <View>
                    <Text style={{color: "#200e36"}}>
                        {label}
                    </Text>
                </View>
            </View>
        </TouchableOpacity>
    )


};